import Actions from "../Pages/actions";
import InfoAction from "../Pages/actions/info";
import Committee from "../Pages/committees";
import ListCommittees from "../Pages/committees/ListCommittees";
import FileManagement from "../Pages/fileManagement";
import FinalDeliberations from "../Pages/finalDeliberations";
import FinalDeliberationInfo from "../Pages/finalDeliberations/Info";
import Home from "../Pages/home/Home";
import ListMeetings from "../Pages/meeting";
import FormMeeting from "../Pages/meeting/FormMeeting";
import FormMeetingInfo from "../Pages/meeting/FormMeetingInfo";
import FormMeetingEdit from "../Pages/meeting/FormMettingEdit";
import Minutes from "../Pages/minutes";
import EditAction from "../Pages/minutes/EditAction";
import Modalities from "../Pages/modalities";
import Role from "../Pages/role";
import ListRole from "../Pages/role/ListRole";
import Slot from "../Pages/slots";
import FormSlot from "../Pages/slots/FormSlot";
import SlotCommitteeDetails from "../Pages/slots/SlotCommitteeDetails/Index";
import AuditListConnection from "../Pages/softwareManagement/pages/Audit/List";
import BusinessUnitConfiguration from "../Pages/softwareManagement/pages/BusinessUnits/Configuration";
import BusinessUnits from "../Pages/softwareManagement/pages/BusinessUnits/List";
import PackageCommitteesConfiguration from "../Pages/softwareManagement/pages/CommittePackage/Configuration";
import ComitteesConfigurationConnection from "../Pages/softwareManagement/pages/Committees/Configuration";
import GroupConfiguration from "../Pages/softwareManagement/pages/Groups/Configuration";
import Groups from "../Pages/softwareManagement/pages/Groups/List";
import ConfigureUsers from "../Pages/softwareManagement/pages/Users/Configure";
import ListUsersConnection from "../Pages/softwareManagement/pages/Users/List";
import Theme from "../Pages/theme";
import ListThemes from "../Pages/theme/ListThemes";

const getRoutes = () => {
  return [
    {
      path: "/",
      resourceName: "home",
      component: Home,
      showMenu: true,
      exact: true,
      icon: "Home",
      softwareManagement: false,
    },
    {
      path: "/error",
      resourceName: "error",
      component: Error,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/finalDeliberations/info/:slotId",
      resourceName: "finalDeliberations",
      component: FinalDeliberationInfo,
      softwareManagement: false,
    },
    {
      path: "/committees",
      resourceName: "committee",
      component: ListCommittees,
      showMenu: true,
      icon: "SupervisedUserCircle",
      funcinality: 'listCommittees',
      softwareManagement: false,
    },
    {
      path: "/committees/:type",
      resourceName: "committee",
      component: ListCommittees,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/committee/new",
      resourceName: "committee",
      component: Committee,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/committee/edit/:id",
      resourceName: "committee",
      component: Committee,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/committee/show/:id",
      resourceName: "committee",
      component: Committee,
      softwareManagement: false,
      props: { disabled: true },
      showMenu: false,
    },
    {
      path: "/minutes/edit",
      resourceName: "minuteActions",
      component: EditAction,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/action/info",
      resourceName: "infoAction",
      component: InfoAction,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/themes",
      resourceName: "theme",
      component: ListThemes,
      showMenu: true,
      icon: "Favorite",
      funcinality: 'listThemes',
      softwareManagement: false,
    },
    {
      path: "/themes/:type",
      resourceName: "theme",
      component: ListThemes,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/theme/new",
      resourceName: "theme",
      component: Theme,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/theme/edit/:id",
      resourceName: "theme",
      component: Theme,
      showMenu: false,
      softwareManagement: false,
    },
    ,
    {
      path: "/modalities/",
      resourceName: "modalities",
      component: Modalities,
      showMenu: true,
      icon: "Favorite",
      funcinality: 'listModalities',
      softwareManagement: false,
    },
    {
      path: "/roles/",
      resourceName: "role",
      component: ListRole,
      showMenu: true,
      icon: "Favorite",
      funcinality: 'listGeneralRules',
      softwareManagement: false,
    },
    {
      path: "/roles/:type",
      resourceName: "role",
      component: ListRole,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/role/new",
      resourceName: "role",
      component: Role,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/role/edit/:id",
      resourceName: "role",
      component: Role,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/committees/add",
      resourceName: "committee",
      component: Committee,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "{`/committees/:committeeId`}",
      resourceName: "theme",
      component: Theme,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/slots",
      resourceName: "slot",
      component: Slot,
      showMenu: true,
      icon: "Favorite",
      funcinality: 'listSlots',
      softwareManagement: false,
    },
    {
      path: "/slots/:type",
      resourceName: "slot",
      component: Slot,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/slot/new",
      resourceName: "slot",
      component: FormSlot,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/slot/committee/:id",
      resourcename: "slot",
      component: SlotCommitteeDetails,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/slot/edit/:id",
      resourceName: "slot",
      component: FormSlot,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/logOff",
      resourceName: "logoff",
      component: Committee,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/meetings",
      resourceName: "meeting",
      component: ListMeetings,
      showMenu: true,
      icon: "Favorite",
      funcinality: 'listMeets',
      softwareManagement: false,
    },
    {
      path: "/meetings/:type",
      resourceName: "meeting",
      component: ListMeetings,
      showMenu: false,
      softwareManagement: false,
    },
    {
      path: "/meeting/new",
      resourceName: "meeting",
      component: FormMeeting,
      softwareManagement: false,
    },
    {
      path: "/meeting/edit/:id",
      resourceName: "meeting",
      component: FormMeetingEdit,
      softwareManagement: false,
    },
    {
      path: "/meeting/info/:id",
      resourceName: "meeting",
      component: FormMeetingInfo,
      softwareManagement: false,
    },
    {
      path: "/meeting/detail/:id",
      resourceName: "meeting",
      component: FormMeetingEdit,
      showMenu: false,
      softwareManagement: false,
    },   
    {
      path: "/minutes",
      resourceName: "minutes",
      component: Minutes,
      softwareManagement: false,
      props: { disabled: true },
      funcinality: 'listMinutes',
      showMenu: true,
    },
    {
      path: "/actions",
      resourceName: "actions",
      component: Actions,
      showMenu: true,
      funcinality: ['listActions', 'updateOwnFocalActions'],
      softwareManagement: false,
    },
    {
      path: "/finalDeliberations",
      resourceName: "finalDeliberations",
      component: FinalDeliberations,
      showMenu: true,
      icon: "SupervisedUserCircle",
      funcinality: 'listDeliberations',
      softwareManagement: false,
    },
    {
      path: "/fileManagement",
      resourceName: "fileManagement",
      component: FileManagement,
      showMenu: true,
      icon: "File",
      funcinality: 'listFiles',
      softwareManagement: false,
    },
    // {
    //   path: "/managementProfiles",
    //   resourceName: "managementProfiles",
    //   component: managementProfiles,
    //   showMenu: true,
    //   funcinality: 'profilesManagement',
    //   icon: "profile",
    //   softwareManagement: false,
    // },
    {
      path: "/system-management/business",
      resourceName: "systemManagementBusinessUnits",
      component: BusinessUnits,
      showMenu: true,
      funcinality: 'systemManagement',
      icon: "gear",      
      softwareManagement: true,
    },
    {
      path: "/system-management/configure-business",
      resourceName: "createBusinessUnits",
      component: BusinessUnitConfiguration,
      showMenu: false,
      funcinality: 'createBusinessUnits',
      softwareManagement: true,
    },
    {
      path: "/system-management/configure-committee-packages",
      resourceName: "createPackageCommittes",
      component: PackageCommitteesConfiguration,
      showMenu: false,
      funcinality: 'createBusinessUnit',
      softwareManagement: true,
    },
    {
      path: "/system-management/groups",
      resourceName: "systemManagementGroups",
      component: Groups,
      funcinality: 'groups',
      softwareManagement: true,
    },
    {
      path: "/system-management/configure-groups",
      resourceName: "createGroups",
      component: GroupConfiguration,
      funcinality: 'createGroups',
      softwareManagement: true,
    },
    {
      path: "/system-management/users",
      resourceName: "listUsers",
      component: ListUsersConnection,
      funcinality: 'listUsers',
      softwareManagement: true,
    },
    {
      path: "/system-management/configure-users",
      resourceName: "configureUsers",
      component: ConfigureUsers,
      funcinality: 'configureUsers',
      softwareManagement: true,
    },
    {
      path: "/system-management/configure-committees",
      resourceName: "configureCommittees",
      component: ComitteesConfigurationConnection,
      funcinality: 'configureCommittees',
      softwareManagement: true,
    },
    {
      path: "/system-management/audit",
      resourceName: "audit",
      component: AuditListConnection,
      funcinality: 'audit',
      softwareManagement: true,
    },
  ];
};

export default getRoutes;
